<div style="page-break-inside: avoid;" class="container mt-5 py-5" [ngClass]="printActive ? 'return-view-background-print' : 'return-view-background'">    
      <div class="row pb-3">
        <div class="col-12 text-center"><u>রিটার্ন ফরম পূরণের ক্ষেত্রে অনুসরণীয় নির্দেশাবলী</u></div>
      </div>
  
      <div class="row mt-4 mb-5" style="border: 2px solid black">
        <div class="col-12 p-2">          

          <div class="row mb-4">
            <div class="col-12">
              ১। এই আয়কর রিটার্ন ব্যক্তি করদাতা অথবা আইনে বর্ণিত নির্ধারিত ব্যক্তি কর্তৃক স্বাক্ষরিত
              ও প্রতিপাদিত হইতে হইবে।
            </div>
          </div>
  
          <div class="row mb-4">
            <div class="col-12">
              ২। প্রযোজ্য ক্ষেত্রে সংযুক্ত করুন-
            </div>
          </div>
  
          <div class="row mb-4">
            <div class="col-2 text-center">
              (ক)
            </div>
            <div class="col-10 text-justify">
              বেতন আয়ের ক্ষেত্রে বেতন বিবরণী, ব্যাংক মুনাফা/সুদের ক্ষেত্রে ব্যাংক বিবরণী, সঞ্চযপত্রের উপর সুদের ক্ষেত্রে সুদ
              প্রদানকারী ব্যাংকের সনদপত্র, গৃহ সম্পত্তি আয়ের ক্ষেত্রে ভাড়ার চুক্তিপত্র, পৌর কর ও খাজনা প্রদানের রশিদ,
              গৃহ ঋণের উপর সুদ থাকিলে ঋণ প্রদানকারী প্রতিষ্ঠানের সনদপত্র/বিবরণী, বিমা কিস্তি প্রদত্ত থাকিলে কিস্তি
              প্রদানের রশিদ, অংশীদারি ফার্মের আয়ের অংশ থাকিলে অংশীদারি ফার্মের কর নির্ধারণ আদেশের কপি/ আয় ব্যয়ের
              হিসাব ও স্থিতিপত্র, মূলধনি মুনাফা থাকিলে প্রমাণাদি, ডিভিডেন্ট আয় থাকিলে ডিভিডেন্ট প্রাপ্তির সনদপত্র, অন্যান্য 
              উৎসের আয় থাকিলে উহার বিবরণী এবং সঞ্চয়পত্র, এল.আই.পি. ডিপিএস, যাকাত, স্টক/শেয়ার ক্রয় ইত্যাদিতে 
              বিনিয়োগ থাকিলে প্রমাণাদি;
            </div>
          </div>
  
          <div class="row mb-4">
            <div class="col-2 text-center">
              (খ)
            </div>
            <div class="col-10 text-justify">
              সংশ্লিষ্ট তফসিল অনুযায়ী অবচয় দাবি সম্বলিত অবচয় বিবরণী;
            </div>
          </div>
  
          <div class="row mb-4">
            <div class="col-2 text-center">
              (গ)
            </div>
            <div class="col-10 text-justify">
              আয়কর আইন, ২০২৩ অনুযায়ী আয় পরিগণনা (প্রযোজ্য ক্ষেত্রে)।
            </div>
          </div>

          <div class="row mb-4">
            <div class="col-12">
              ৩। পৃথক বিবরণী সংযুক্ত করুন-
            </div>
          </div>
  
          <div class="row mb-4">
            <div class="col-2 text-center">
              (ক)
            </div>
            <div class="col-10 text-justify">
              করদাতার স্ত্রী বা স্বামী (করদাতা না হইলে), নাবালক সন্তান ও নির্ভরশীলের নামে কোনো আয় থাকিলে;
            </div>
          </div>
  
          <div class="row mb-4">
            <div class="col-2 text-center">
              (খ)
            </div>
            <div class="col-10 text-justify">
              সংশ্লিষ্ট তফসিল এবং এস.আর.ও. অনুযায়ী কর অব্যাহতি প্রাপ্ত ও করমুক্ত আয়ের বিবরণ;
            </div>
          </div>
  
          <div class="row mb-4">
            <div class="col-2 text-center">
              (গ)
            </div>
            <div class="col-10 text-justify">
              আয়কর আইন, ২০২৩ এর ষষ্ঠ তফসিলের অংশ ১ অনুযায়ী ঘোষিত কর অব্যাহতি প্রাপ্ত আয়।
            </div>
          </div>
  
          <div class="row mb-4">
            <div class="col-12">
              ৪। দাখিলকৃত দলিলপত্রাদি করদাতা অথবা করদাতার ক্ষমতাপ্রাপ্ত প্রতিনিধি কর্তৃক স্বাক্ষরিত হইতে হইবে।
            </div>
          </div>

          <div class="row mb-4">
            <div class="col-12">
              ৫। নিম্নবর্ণিত তথ্য প্রদান করুন-
            </div>
          </div>
  
          <div class="row mb-4">
            <div class="col-2 text-center">
              (ক)
            </div>
            <div class="col-10 text-justify">
              করদাতা অংশীদার হইলে টি আইএনসহ ফার্মের নাম ও ঠিকানা;
            </div>
          </div>
  
          <div class="row mb-4">
            <div class="col-2 text-center">
              (খ)
            </div>
            <div class="col-10 text-justify">
              করদাতা পরিচালক হইলে কোম্পানি/কোম্পানিসমূহের টি আইএনসহ নাম ও ঠিকানা।
            </div>
          </div>

          <div class="row mb-4">
            <div class="col-12">
             ৬। করদাতার নিজের, স্বামী/স্ত্রী (যদি তিনি করদাতা না হন), নাবালক সন্তান এবং নির্ভরশীলদের সম্পদ ও দায় বিবরণী 
              আইটি-১০বি(২০২৩) অনুসারে প্রদর্শন করিতে হইবে।
            </div>
          </div>

          <div class="row mb-4">
            <div class="col-12">
              ৭। করদাতা বা তাঁহার আইনানুগ প্রতিনিধির স্বাক্ষর বাধ্যতামূলক।
            </div>
          </div>

          <div class="row mb-4">
            <div class="col-12">
              ৮। স্বাভাবিক ব্যক্তি করদাতাদের ক্ষেত্রে আইটি-১০বি(২০২৩) ও আইটি-১০বিবি(২০২৩)- তে স্বাক্ষর প্রদান বাধ্যতামূলক।
            </div>
          </div>

  
          <div class="row mb-4">
            <div class="col-12">
              ৯। স্থান সংকুলান না হইলে প্রয়োজনে পৃথক কাগজ ব্যবহার করা যাইবে।
            </div>
          </div>

          <div class="blank-space"></div>

        </div>
      </div>    
</div>
  